import React from 'react';
import classNames from 'classnames';
import './FieldTypeDisplay.less';

interface IFieldTypeDisplayProps extends React.HTMLProps<{}> {
  entityTypeName?: string; // this is too editor specific for ./inputs
  isList?: boolean;
}

const getClassName = (className?: string) => classNames('dpc-field-type-display', className);

const getDisplayLabel = (entityTypeName?: string, isList?: boolean) =>
  classNames(
    {
      'List of': isList, // using classnames here for convenience.
    },
    entityTypeName
  );

/**
 * Show type name for editors such as a mapping editor.
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function FieldTypeDisplay({ children, className, entityTypeName, isList }: IFieldTypeDisplayProps) {
  // TODO "List of" readout...

  return (
    <div className={getClassName(className)} title={entityTypeName}>
      {getDisplayLabel(entityTypeName, isList)}
      {children}
    </div>
  );
}
